 
import  Map from './map.js';
import '../css/Loct_common.css';
import React, {useState} from 'react';
import arrow_D from '../../HumanResource/img/icon_btn_arrow_down.png';
import arrow_U from '../../HumanResource/img/icon_btn_arrow_up.png';
import Text from '../../../common/Text.js';

 

 
 
function Loct_common(props)  {
     
   const [showMap, setShowMap] = useState(false); // 지도 표시 상태


   const imgsrc=props.imgsrc;
   const companyNm=props.companyNm;
   const adress=props.adress;
   const number=props.number;
   const fex=props.fex;
   const imgId=props.imgId;
   const mapid=props.mapid;
   const weedo=props.weedo;
   const gungdo=props.gungdo;

       return (
       <div className='grpMap' >
            <div className='line1' >
               <img className="Loct_img" src={imgsrc}/>
            
               {/* <p className='line3' style={{ width : '62.5%'}}></p> */}
               <p className='line3' >
                  <Text variant="px24w600_Blue" >
                         <div className="value">{companyNm}</div>
                  </Text>
                  <div className='line4'>
                  <nav className='adress'>
                     
                  <Text variant="px16w400" >
                  <div className='itemT'>주소</div></Text>
                  
                  <Text variant="px16w400" >
                  <div className='itemC'>{adress}</div></Text>
                        </nav>
                        <nav className='phone'>
                  <Text variant="px16w400" >
                  <div className='itemT'>대표전화</div></Text>
                  <Text variant="px16w400" >
                  <div className='itemC'>{number}</div></Text>
                        </nav>
                        <nav className='fex'>
                  <Text variant="px16w400" >
                  <div className='itemT'>팩스</div></Text>
                  <Text variant="px16w400" >
                  <div className='itemC'>{fex}</div></Text>
                        </nav>
                     </div>
               </p>


             <div class = 'btnmapgrp' >
             <button  className={showMap ? 'button active' : 'buttonmap'} onClick={() => setShowMap(!showMap)}> {showMap ? 
             <Text variant="px16w400_map" >
             <div className='btnMap'>지도 보기</div></Text> : 
             <Text variant="px16w400_map" >
             <div className='btnMap'>지도 보기</div></Text>}
              <img class = 'arrowImg' id = {imgId} src={showMap? arrow_U : arrow_D} ></img>
             </button>
             </div>
            
             
            </div>

         
           {/* showMap이 true일 때만 지도를 보여줌 */}
           {showMap && (
                              <Map class = 'map' mapid={mapid} gungdo={gungdo} weedo={weedo} />
                        )}
          
       </div>
               
     );
    
   }

   export default Loct_common;